
export default function routerBeforePaymentPage(to, from, next) {
  if (from.name !== 'orderAheadCheckoutSummaryPage') {
    next({
      name: 'orderMenu',
      params: { merchantId: to.params.merchantId }
    });
  }
  else {
    next();
  }
}
